// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_85-4";
export var collapsed = "_85-1";
export var headerBar = "_85-0";
export var leftHeaderContent = "_85-3";
export var subjectContainer = "_85-2";